<avi-data-grid
    [config]="policyGridConfig"
    [rows]="policyGridRows"
>
    <ng-template
        #policiesAppliedFieldTemplateRef
        let-row
        let-index="index"
    >
        <div class="vs-log-policy-grid__row">
            <div class="vs-log-policy-grid__row-label">
                {{ row.label }}
            </div>
            <div class="vs-log-policy-grid__row-value">
                {{ row.applied }}
            </div>
        </div>
    </ng-template>
</avi-data-grid>
